// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Q0+wt","skeleton":"style_skeleton__OCds0"};